import SchoolDefaultLogo from "../../../assets/img/school-default-logo.png";
import { beautifyDurationUnit, toCurrency } from "../../../helpers";
import {
  ILanguageCourseCardBackEndModel,
  ILanguageCourseCardFrontEndModel,
} from "../types";
import { beautifyRequiredDocuments } from "./helperFunctions";
import {
  calcFeeWithDiscount,
  sumPriceAndOtherFeesSupports,
} from "../../language-course/helpers/helperFunctions";
import { COURSE_TYPES, LANGUAGES } from "../../language-course/constants";

function parser(course: ILanguageCourseCardBackEndModel) {
  const discount =
    course.hasPriceDiscount || course.hasOtherFeesDiscount
      ? "Discount is Available"
      : "N/A";

  const housingTypeNames = course.housingTypeNames.length
    ? course.housingTypeNames
    : ["N/A"];

  const otherFeesTotal = toCurrency(
    course.otherFeesTotal,
    course.currency,
    " ",
    "code",
  );

  const capitalizedRequiredDocuments = beautifyRequiredDocuments(
    course.requiredDocs,
  );

  const { hasSupport: hasPriceSupport, calcFee: calcPrice } =
    calcFeeWithDiscount({
      fee: course.price,
      hasFeeDiscount: course.hasPriceDiscount,
      feeDiscountType: course.priceDiscountType,
      feeDiscountAmount: course.priceDiscountAmount,
      currency: course.currency,
    });

  const { hasSupport: hasOtherFeesSupport, calcFee: calcOtherFees } =
    calcFeeWithDiscount({
      fee: course.otherFeesTotal,
      hasFeeDiscount: course.hasOtherFeesDiscount,
      feeDiscountType: course.otherFeesDiscountType,
      feeDiscountAmount: course.otherFeesDiscountAmount,
      currency: course.currency,
    });

  const {
    priceOtherFeesSumWithCurrency,
    priceOtherFeesWithSupportsSumWithCurrency,
    hasFeesSupport,
  } = sumPriceAndOtherFeesSupports(
    course.price,
    hasPriceSupport,
    calcPrice,
    course.otherFeesTotal,
    hasOtherFeesSupport,
    calcOtherFees,
    course.currency,
  );

  const courseDuration = `${course.durationAmount} ${beautifyDurationUnit(
    course.durationAmount,
    course.durationUnit,
    "Course",
  )}`;

  const priceDuration = `${
    course.priceDurationAmount === null ? "" : course.priceDurationAmount + " "
  }
        ${beautifyDurationUnit(
          course.priceDurationAmount,
          course.priceDurationUnit,
          "Course",
        )}`;

  const totalPriceWithUnit =
    priceOtherFeesWithSupportsSumWithCurrency + " / " + priceDuration;

  const schoolImage = course.school.image?.preview ?? SchoolDefaultLogo;

  const branchesCountry = course.branches
    .map((branch) => {
      const nameParts = branch.name.split(", ");

      return nameParts[nameParts.length - 1];
    })
    .join(", ");

  const parsedProgram: ILanguageCourseCardFrontEndModel = {
    discount,
    schoolImage,
    hasFeesSupport,
    courseDuration,
    otherFeesTotal,
    branchesCountry,
    housingTypeNames,
    totalPriceWithUnit,
    capitalizedRequiredDocuments,
    priceOtherFeesSumWithCurrency,
    id: course.id,
    isMasked: course.isMasked,
    branches: course.branches,
    schoolName: course.school.name,
    courseType: {
      type: course.courseType,
      name: COURSE_TYPES.find((type) => type.id === course.courseType)!.name,
    },
    language: LANGUAGES.find((l) => l.id === course.language)!.name,
    category: course.category,
  };

  return parsedProgram;
}

export function parseToLanguageCourseCardsFrontEndModel(response) {
  return {
    data: response.data?.data.map((course) => parser(course)),
    totalCount: response.data?.totalCount,
  };
}
